import type React from "react";
import { useMemo } from "react";
import { useDrop } from "react-dnd";
import { HiBadgeCheck } from "react-icons/hi";
import { VscError } from "react-icons/vsc";
import style from "./DropPlaceholder.module.scss";

type Props = {
	onDropWord: (
		originalIndex: number,
		word: string,
		currentPlaceholderIndex: number,
	) => void;
	droppedWord: { word: string; originalIndex: number };
	onRemoveWord: (
		w: { word: string; originalIndex: number },
		currentPlaceholderIndex: number,
	) => void;
	correct?: null | boolean;
	matchWithAudio?: boolean;
	currentPlaceholderIndex: number;
};

type WordToDropType = {
	word: { originalIndex: number; word: string };
};

export const DropPlaceholder: React.FC<Props> = ({
	onDropWord,
	droppedWord,
	onRemoveWord,
	correct,
	currentPlaceholderIndex,
}) => {
	const prefixClass = "fill-in-gaps";
	const [{ isOver }, drop] = useDrop({
		accept: "words-defs",
		drop: (item: WordToDropType) => {
			const { word } = item;
			return onDropWord(word.originalIndex, word.word, currentPlaceholderIndex);
		},
		canDrop: () => !droppedWord.word,
		collect: (monitor) => ({
			isOver: !!monitor.isOver(),
		}),
	});

	const backgroundClass = useMemo(() => {
		return correct === undefined ? "" : correct ? "-correct" : "-incorrect";
	}, [correct]);

	return (
		<div className={style[`${prefixClass}__placeholder-item`]}>
			<button
				type="button"
				onClick={
					droppedWord.word
						? () => onRemoveWord(droppedWord, currentPlaceholderIndex)
						: () => {}
				}
				ref={drop}
				className={style[`${prefixClass}__dropped-word${backgroundClass}`]}
				style={{ backgroundColor: isOver ? "lightgray" : "white" }}
			>
				{droppedWord.word ? (
					<>
						<p>{droppedWord.word}</p>
						{correct && correct !== undefined && (
							<HiBadgeCheck className={style[`${prefixClass}__correct-icon`]} />
						)}
						{!correct && correct !== undefined && (
							<VscError className={style[`${prefixClass}__incorrect-icon`]} />
						)}
					</>
				) : (
					<p className={style[`${prefixClass}__placeholder-text`]}>here</p>
				)}
			</button>
		</div>
	);
};
